function getPaginationPage(page: number | string): number {
  return typeof page === 'string' ? parseInt(page) : page
}

export { getPaginationPage }
